import React from 'react';
import './BackupAdTimeline.css';

interface TimelineFrame {
  timestamp: number;
  screenshot: string;
  description: string;
}

interface BackupAdTimelineProps {
  frames: TimelineFrame[];
  totalDuration: number;
}

export const BackupAdTimeline: React.FC<BackupAdTimelineProps> = ({ frames, totalDuration }) => {
  const [expanded, setExpanded] = React.useState(false);

  if (!frames || frames.length === 0) return null;

  return (
    <div className="backup-ad-timeline">
      <div className="timeline-header" onClick={() => setExpanded(!expanded)} style={{ cursor: 'pointer' }}>
        <h3>Backup Ads Timeline</h3>
        <span>{(totalDuration / 1000).toFixed(1)}s total</span>
          <span style={{ fontSize: '12px', color: '#999' }}>{expanded ? "\u25BC" : "\u25B6"}</span>
      </div>
      {expanded && <div className="timeline-frames">
        {frames.map((frame, idx) => (
          <div key={idx} className="timeline-frame">
            <div className="frame-time">{(frame.timestamp / 1000).toFixed(1)}s</div>
            <div className="frame-image">
              {frame.screenshot && (
                <img src={`data:image/jpeg;base64,${frame.screenshot}`} alt={`Frame ${idx}`} />
              )}
            </div>
          </div>
        ))}
      </div>}
    </div>
  );
};